export default () => {
  const moments = new Swiper('.moments-swiper:not(.moments-elearning-swiper)', {
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
    },
    slidesPerView: 4,
    spaceBetween: 40,
    grabCursor: true,
    simulateTouch: true,
    preventClicks: true,
    keyboardControl: true,
    paginationClickable: true,
    navigation: {
      nextEl: '.next-moment',
      prevEl: '.prev-moment',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        grid: {
          rows: 2,
        },
        spaceBetween: 16,
        pagination: {
          el: '.swiper-pagination-3-mobile',
          clickable: true,
        },
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 40,
        slidesPerGroup: 3,
        pagination: {
          el: '.swiper-pagination-3',
          clickable: true,
        },
      },
      2048: {
        slidesPerView: 4,
        spaceBetween: 40,
        slidesPerGroup: 4,
        pagination: {
          el: '.swiper-pagination-3',
          clickable: true,
        },
      },
    },
  });
};
